<template>
  <div class="plv-iar-checkIn-list" :class="{'plv-iar-checkIn-list--mobile': isMobile}">
    <div v-if="!list || list.length === 0" class="plv-iar-checkIn-list__empty">
      <span>{{ iarTrans('checkIn.NoRecord') }}</span>
    </div>
    <c-table
      v-else
      :columns="columns"
      :data-list="list"
      tbody-height="100%">
      <template #slotTime="{slotData}">
        <span class="plv-iar-checkIn-item__createTime">{{ slotData.createTime }}</span>
      </template>
      <template #slotStatus="{slotData}">
        <span v-if="slotData.checked === 'Y'" class="plv-iar-checkIn-item__status"> {{ iarTrans('checkIn.checkInOver') }} </span>
        <span v-else-if="slotData.checked === 'N'" class="plv-iar-checkIn-item__status plv-iar-checkIn-item__status--red" > {{ iarTrans('checkIn.checkInNot') }} </span>
      </template>
    </c-table>
  </div>
</template>

<script>
import CTable from '../../../components/common/table/Table.vue';
import basicMixin from '../../../assets/mixins/basic';
import { isMobile } from '@polyv/utils/src/browser';
import { formatDate } from '@polyv/utils/src/date';
export default {
  name: 'checkInlist',
  mixins: [basicMixin],
  components: {
    CTable
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      isMobile: isMobile(),
    };
  },
  computed: {
    columns() {
      return [
        {
          label: this.iarTrans('checkIn.checkInTime'),
          props: 'createTime',
          textAlign: 'left',
          slotName: 'slotTime'
        },
        {
          label: this.iarTrans('checkIn.checkInStatus'),
          props: 'checked',
          width: '140px',
          slotName: 'slotStatus'
        },
      ];
    }
  },
  methods: {
    formatDate(time) {
      return formatDate(time, 'YYYY.MM.DD hh:mm:ss');
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/styles/basic.scss';
.plv-iar-checkIn-list__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.plv-iar-checkIn-list {
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  overflow: auto;
  max-height: 400px;
  margin-bottom: 20px;
  @include scrollbar();
  .plv-iar-checkIn-item__createTime {
    text-align: left;
  }
  .plv-iar-checkIn-item__status--red {
    color: #FF5722;
  }
  .plv-ia-c-table-wrapper-table-tbody--inner {
    position: relative !important;
    height: auto !important;
  }
  .plv-ia-c-table-wrapper .plv-ia-c-table-wrapper-table-tbody-tr {
    .plv-ia-c-table-wrapper-table-tbody-td {
      padding: 0;
      font-size: 14px;
    }
    .plv-ia-c-table-wrapper-table-tbody-td:first-child {
      padding: 0 16px;
    }
  }
  .plv-ia-c-table-wrapper-table-thead-th:first-child {
    padding: 0 16px;
  }
}
.plv-iar-checkIn-list--mobile {
  padding: 24px 16px;
}
</style>
